<script>
import FileInput from '@/Components/Forms/FileInput.vue'
export default {
    components: {
        FileInput
    },
    data() {
        return {
            form: this.$inertia.form({
                avatar: null
            }),
            avatarImage: this.getAvatarImage(),
            formErrors: [],
            showErrorsModal: false,
            loading: false
        }
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.uploadAvatar()
            }
        }
    },
    methods: {
        getAvatarImage() {
            return this.$page.props.auth.user.avatarImage
        },
        uploadAvatar() {
            if (!this.loading) {
                this.loading = true
                if (this.form.avatar === null || this.form.avatar.length < 1) {
                    this.loading = false
                    return
                }
                if (this.formErrors.length > 0) {
                    return
                }
                const formData = new FormData()
                formData.append('avatar', this.form.avatar[0])
                axios.post(this.$route('ajax.avatar.update'), formData)
                    .then((response) => {
                        this.avatarImage = response.data.avatar
                        this.loading = false
                        this.$page.props.flash.success = response.data.message
                    })
                    .catch((error) => {
                        if (error.response.status === 413) {
                            this.$page.props.flash.error = 'Your file is too large, please try uploading a smaller file.'
                        } else {
                            this.$page.props.flash.error = Array.isArray(error.response.data.errors.avatar) && error.response.data.errors.avatar.length > 0 ? error.response.data.errors.avatar[0] : 'There was an error updating your avatar, please try again.'
                        }
                        this.loading = false
                    })
            }
        },
        updateErrors(errors) {
            this.formErrors = errors
            if (this.formErrors.length > 0) {
                this.$page.props.flash.error = `${this.formErrors[0].name} could not be uploaded due to incorrect file ${this.formErrors[0].errorType}`
                this.formErrors = []
                this.loading = false
            }
        }
    }
}
</script>

<template>
    <div class="flex space-x-4">
        <div class="hidden flex-col justify-center leading-tight text-right text-spotler-gray-800 xl:flex">
            <div class="text-xs font-bold uppercase">
                {{ $page.props.auth.user.fullName }}
            </div>
            <div class="text-2xs">
                {{ $page.props.auth.tenant.name }}
            </div>
        </div>
        <div
            class="relative"
            :class="{'pointer-events-none': loading}"
        >
            <form
                ref="avatarForm"
                class="m-0"
                @submit.prevent="uploadAvatar"
            >
                <FileInput
                    ref="avatarInput"
                    v-model="form.avatar"
                    dusk-selector="avatarInput"
                    :multiple="true"
                    accept="image/*"
                    :reset-on-upload="true"
                    :draggable="true"
                    :display-preview="false"
                    :display-errors="false"
                    @errors="updateErrors"
                >
                    <template #drag-area>
                        <div
                            id="a"
                            class="group overflow-hidden relative w-10 h-10 bg-rss-blue-500 rounded-full border-2 border-rss-grayblue-600 pointer-events-none"
                            data-max-upload-size="64M"
                            data-upload-action="#"
                        >
                            <div class="flex absolute left-full group-hover:left-0 z-10 justify-center items-center w-full h-full text-white bg-rss-grayblue-600/75 opacity-0 group-hover:opacity-100">
                                <i
                                    class="text-xl fa fa-camera"
                                    aria-hidden="true"
                                />
                            </div>
                            <div
                                v-if="loading"
                                class="flex absolute inset-0 justify-center items-center text-white bg-rss-grayblue-600/75 rounded-full"
                            >
                                <i class="text-xl fa fa-spinner fa-spin" />
                            </div>
                            <img
                                class="object-cover w-10 userimg"
                                :src="avatarImage"
                                alt=""
                            >
                        </div>
                    </template>
                </FileInput>
            </form>
        </div>
    </div>
</template>
